import { Vue, Prop, Component } from 'vue-property-decorator'
import { VContainer } from 'vuetify/lib'

@Component({})
export default class IFrame extends Vue {
	@Prop({ type: String, required: false }) token!: string
	@Prop({ type: String, required: true }) url!: string

	render() {
		if (!this.token) this.token = this.userToken
		return this.renderIframe()
	}

	renderIframe() {
		return (
			<VContainer height="100%">
				<iframe width="100%" height="100%" src={`${this.url}${this.token}`} />
			</VContainer>
		)
	}

	get userToken() {
		const { state } = this.$store
		return state.user?.accessToken ?? ''
	}
}
